const commonMessages = {
  IMAGE_FORMAT: "Please select a valid image file (JPEG, JPG, PNG).",
  VIDEO_FORMAT:
    "Please select a valid image file (mp4, avi, mov,mkv,wmv,flv, or webm).",
  DOC_FORMAT: "Please select a valid doc file (PDF, DOC, TXT, or DOCX)",
  PDF_FORMAT: "Please select a valid PDF file",
  AUDIO_FORMAT: "Please select a valid audio file (MP3, WAV, or OGG).",
  EMAIL_REQUIRED: "Email is required.",
  INVALID_EMAIL: "Please enter the valid email.",
  INVALID_MOBILE: "Please enter the valid mobile.",
  PASSWORD_REQUIRED: "Password is required.",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required.",
  CONFIRM_PASSWORD_MATCH: "Confirm password must be equal to password",
  NEW_PASSWORD_REQUIRED: "New Password is required.",
  INVALID_PASSWORD:
    "Password should have at least 8 characters and contain uppercase letters,lowercase letters, special characters, and numeric values.",
  NAME_REQUIRED: "Name is required",
  FIRST_NAME_REQUIRED: "First name is required",
  IS_REGISTER: "Is Register must be boolean value.",
  EMAIL_OTP_REQUIRED: "Email OTP is required.",
  MOBILE_OTP_REQUIRED: "Mobile OTP is required",
  MOBILE_REQUIRED: "Mobile number is required.",
  INVALID_NAME:
    "The name must be at least 3 characters long and not start with number.",
  INVALID_USERNAME: "Please enter valid user name.",
  USERNAME_REQUIRED: "Username is required.",
  ALLOW_RESEARCHER: "Only researcher is allow to login",
  OLD_PASSWORD_REQUIRED: "Old Password is required.",
  SUPPORT_MESSAGE_REQUIRED: "Support message is required.",
  USER_NAME_REQUIRED: "Name is required.",
  INVALID_BASE64: "Invalid base64 URL.",
  INVALID_BASE64_FORMAT: "Base64 URL format is incorrect.",
  MIME_NOT_FOUND: "MIME type not found in base64 URL.",
  SURVEY_TITLE_REQUIRED: "Survey title is required.",
  SURVEY_CATEGORY_REQUIRED: "Survey category is required.",
  EXPIRY_DATE_REQUIRED: "Expiry date is required.",
  SURVEY_DESCRIPTION_REQUIRED: "Survey description is required.",
  SURVEY_DURATION_REQUIRED: "Survey duration is required.",
  SURVEY_BLOCK_TITLE_REQUIRED: "Survey block title is required.",
  BLOCK_TITLE_ALREADY_ADDED: "This block title is already added.",
  SURVEY_BLOCK_MORE_THAN_LIMIT: "You cannot add more than 5 blocks.",
  SURVEY_BLOCK_QUESTION_LIMIT:
    "You cannot add more than 15 questions to this block.",
  PARTICIPANT_FEEDBACK_REASON: "Feedback reason is required.",
};

export default commonMessages;
